// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { VehicleIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { VehicleDataOverrideAreaRoutes } from './VehicleDataOverrideAreaRoutes'

export const VehicleDataOverrideAreaNavigationIcon = VehicleIcon

export const VehicleDataOverrideAreaNavigation = ({
  onClick,
  open,
}: AreaNavigationProps) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={t('vehicleDataOverride_navigation_label')}
      to={VehicleDataOverrideAreaRoutes.route}
      Icon={VehicleIcon}
    />
  )
}
